import {
  useEffect, useLayoutEffect, useRef, useState
} from 'react';

// useLayoutEffect warns during server rendering (ProjectsOverview is server-rendered
// standalone), so fall back to useEffect where there is no DOM.
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export function useContainerWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useIsomorphicLayoutEffect(() => {
    if (!ref.current) return undefined;
    // Measure before the first paint. Waiting for the ResizeObserver's first callback left
    // width at 0 for a painted frame, and ProjectsOverview renders its loading skeleton while
    // width is 0 - so every remount (e.g. switching back to the Projects tab in Dashboard
    // Snapshot, with the projects already cached) flashed the skeleton (WOR2-1050).
    setWidth(ref.current.getBoundingClientRect().width);
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
}
